import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "nestedValue",
    pure: false,
})
export class NestedValuePipe implements PipeTransform {
    transform(obj: any, path: string): any {
        if (path === "") return obj;
        const val = path.split(".").reduce((acc, part) => acc?.[part], obj);
        return val ?? "";
    }
}
